import React, { useEffect, useState } from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  LayoutDashboard, Users, Car, CalendarDays, FileText,
  LogOut, Building2, Wallet, FileSignature, Receipt, UserCircle2, PalmtreeIcon, PartyPopper,
  Sparkles, ArrowLeft, ImagePlus, Link2, MessagesSquare, AlertOctagon, MapPin, PhoneCall,
  GraduationCap, Award, UsersRound, ShoppingCart, PackageSearch, Package,
  Database, History, CalendarClock, ClipboardCheck, Lightbulb, HardHat, Clock,
  Briefcase, HeartHandshake, Handshake, ChevronDown, Wrench, ShieldPlus, ShieldAlert, Menu, X, FolderKanban,
  Calculator, ScrollText, Landmark, Radar, Archive, Users2, CheckCircle2, Upload,
  Bell, BarChart3, MessageSquareText, KeyRound, ListChecks, Zap, RefreshCw, ArrowDownToLine, Mail, Inbox, PenLine, TrendingUp, Activity, CreditCard, Kanban, Truck, Cloud, FileCheck2, BookOpen, Flame, ShieldCheck, Send,
  Map, Workflow, MailQuestion, Search as SearchIcon, XCircle, Share2, Route, Globe2, ReceiptText, RotateCcw, LayoutGrid, Banknote, ClipboardList, Eye, Star, Settings2, ArrowUpRight, Hammer } from "lucide-react";
import { pasVoorkeurenToe, LEGE_VOORKEUREN } from "@/lib/menuVoorkeuren";
import { naarDomeinen, domeinVoorPad } from "@/lib/menuDomeinen";
import { useDynModules } from "@/lib/dynModules";
import { HubBar } from "@/components/nav/HubBar";
import { MenuZoeker } from "@/components/nav/MenuZoeker";
import { HubFlyout } from "@/components/nav/HubFlyout";
import { TopBar } from "@/components/nav/TopBar";
import { useMenuIndeling } from "@/context/MenuIndelingContext";
import { MenuInstellingenDialoog } from "@/components/menu/MenuInstellingenDialoog";
import { VerborgenMenu } from "@/components/menu/VerborgenMenu";
import { MenuSnelActie, useLangDruk } from "@/components/menu/MenuSnelActie";
import { useAuth } from "@/context/AuthContext";
import { EIGEN_MODULES, INFORMATIEF_MODULES } from "@/lib/rechtenModules";
import { startAlleenLezenScanner, stopAlleenLezenScanner } from "@/lib/alleenLezenScanner";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { api } from "@/lib/api";
import MobileTabBar from "@/components/MobileTabBar";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";
import MeldingenCentrum from "@/components/MeldingenCentrum";
import OnboardingWizard from "@/components/OnboardingWizard";
import NoodcontactModal from "@/components/NoodcontactModal";
import IdVerzoekModal from "@/components/IdVerzoekModal";
import LocatieTracker from "@/components/LocatieTracker";
import FloatingVoiceAssistant from "@/components/FloatingVoiceAssistant";
import MilestoneCelebration from "@/components/MilestoneCelebration";
import WelkomOverlay, { ROLE_INFO as WELKOM_ROLE_INFO, initialsFrom } from "@/components/WelkomOverlay";
import GlobalSearch from "@/components/GlobalSearch";
import { WerkveldSchakelaar } from "@/components/WerkveldSchakelaar";
import MeldKnop from "@/components/MeldKnop";
import RondleidingKnop from "@/components/rondleiding/RondleidingKnop";
import PdfViewer from "@/components/PdfViewer";
import WatIsNieuw from "@/components/WatIsNieuw";
import { MessageSquareWarning, Gavel, Scale } from "lucide-react";
import { useFlags } from "@/hooks/useFlags";
import { LayoutV2Schakelaar } from "@/components/layout_v2/LayoutV2Schakelaar";
import { isManager, isManagement, MANAGERS, MANAGEMENT, heeftRol, rollenVan, rolLabel, canon } from "@/lib/rollen";
import { useLayoutV3 } from "@/hooks/useLayoutV3";
import { V3Rail } from "@/components/v3/V3Rail";
import { V3HubPaneel } from "@/components/v3/V3HubPaneel";
import { V3TopBar, LayoutV3Knop } from "@/components/v3/V3TopBar";
import { V3BottomNav } from "@/components/v3/V3BottomNav";
import { V3MeerSheet } from "@/components/v3/V3MeerSheet";
import { useSmal } from "@/hooks/useSmal";
import { useTabelKaarten } from "@/hooks/useTabelKaarten";

// Rol hiërarchie
const ROLE_LEVEL = {
  manager_plus: 100, directie: 100,
  manager: 80, manager_operationeel: 80, manager_bedrijfsvoering: 80, manager_brandveiligheid: 80,
  manager_hr: 80, manager_algemeen: 80,
  teammanager: 60,
  kcc: 50, accountmanager: 50,
  buitendienst: 40, buitendienst_nl: 40, buitendienst_be: 40,
  salesteam: 30,
  projectleider_pb: 25,
  applicateur: 20,
  medewerker: 10,
};
const level = (r) => Math.max(0, ...rollenVan(r).map((x) => ROLE_LEVEL[x] || 0));
const isManagerRole = (r) => level(r) >= 60;
const isBuitendienst = (r) => ["buitendienst", "buitendienst_nl", "buitendienst_be"].includes(r);

// Menu items per rol — gestructureerd in categorieën.
// Applicateur en Projectleider PB hebben expliciet gedefinieerde beperkte menu's.

function menuFor(role) {
  // Applicateur = ZZP — strikt beperkt
  if (role === "applicateur") {
    return [{
      cat: "Mijn werkomgeving",
      icon: HardHat,
      items: [
        { to: "/dashboard", label: "Overzicht", icon: LayoutDashboard, tid: "nav-dashboard", module: "Dashboard" },
        { to: "/mijn-gegevens", label: "Mijn gegevens", icon: UserCircle2, tid: "nav-mijn-gegevens" },
        { to: "/mijn-handtekening", label: "Mijn handtekening", icon: PenLine, tid: "nav-signature" },
        { to: "/projecten", label: "Projecten BB", icon: HardHat, tid: "nav-projecten", counter: "projecten", module: "Projecten BB" },
        { to: "/cursussen", label: "Cursussen & Trainingen", icon: GraduationCap, tid: "nav-training", module: "Training" },
        { to: "/handboek", label: "Handboek", icon: BookOpen, tid: "nav-handboek", module: "Handboek" },
        { to: "/snelkoppelingen", label: "Snelkoppelingen", icon: Link2, tid: "nav-links", module: "Snelkoppelingen" },
        { to: "/verbeteringen", label: "Verbetering melden", module: "Verbeteringen", icon: Lightbulb, tid: "nav-verbeteringen" },
      ],
    }];
  }

  // Projectleider PB — geen bekwaamheden, geen financieel
  if (role === "projectleider_pb") {
    return [
      {
        cat: "Mijn werk",
        icon: Briefcase,
        items: [
          { to: "/dashboard", label: "Overzicht", icon: LayoutDashboard, tid: "nav-dashboard", module: "Dashboard" },
          { to: "/mijn-gegevens", label: "Mijn gegevens", icon: UserCircle2, tid: "nav-mijn-gegevens" },
          { to: "/mijn-handtekening", label: "Mijn handtekening", icon: PenLine, tid: "nav-signature" },
          { to: "/verlof", label: "Mijn verlof", icon: PalmtreeIcon, tid: "nav-verlof", module: "Verlof" },
        ],
      },
      {
        cat: "Passieve brandveiligheid",
        icon: HardHat,
        items: [
          { to: "/projecten", label: "Projecten BB", icon: HardHat, tid: "nav-projecten", counter: "projecten", module: "Projecten BB" },
          { to: "/bb-pipeline", label: "BB Pipeline (leads & projecten)", icon: Kanban, tid: "nav-bb-pipeline", module: "BB Pipeline" },
          { to: "/bb-klanten", label: "BB Klantenlijst", icon: Building2, tid: "nav-bb-klanten", module: "BB Klantenlijst" },
          { to: "/bb-documenten", label: "BB Documenten", icon: FileText, tid: "nav-bb-documenten", module: "BB Documenten" },
          { to: "/bb-materialen", label: "BB Materialen (Mulcol)", icon: Package, tid: "nav-bb-materialen", module: "Projecten BB" },
          { to: "/bb-onderaannemers", label: "BB Onderaannemers & overeenkomsten", icon: Handshake, tid: "nav-bb-onderaannemers", module: "Projecten BB" },
          { to: "/bb-onderaannemers?tab=overdrachten", label: "BB Overdrachtsdocumenten", icon: ClipboardList, tid: "nav-bb-overdrachten", module: "Projecten BB" },
          { to: "/tickets", label: "Tickets", icon: MessagesSquare, tid: "nav-tickets", counter: "tickets", module: "Tickets" },
          { to: "/klachten", label: "Klachten", icon: AlertOctagon, tid: "nav-klachten", counter: "klachten", module: "Klachten" },
        ],
      },
      {
        cat: "Documenten & snelkoppelingen",
        icon: FileText,
        items: [
          { to: "/documenten", label: "Documenten", icon: FileText, tid: "nav-documenten", module: "Documenten" },
          { to: "/snelkoppelingen", label: "Snelkoppelingen", icon: Link2, tid: "nav-links", module: "Snelkoppelingen" },
        ],
      },
      {
        cat: "Overig",
        icon: LayoutDashboard,
        items: [
          { to: "/cursussen", label: "Cursussen & Trainingen", icon: GraduationCap, tid: "nav-training", module: "Training" },
        { to: "/handboek", label: "Handboek", icon: BookOpen, tid: "nav-handboek", module: "Handboek" },
          { to: "/mail-templates", label: "Mailsjablonen", icon: Mail, tid: "nav-mail-sjablonen" },
          { to: "/locaties", label: "Vestigingen", icon: MapPin, tid: "nav-locaties", module: "Vestigingen" },
          { to: "/verbeteringen", label: "Verbetering melden", module: "Verbeteringen", icon: Lightbulb, tid: "nav-verbeteringen" },
          { to: "/ai-assistent", label: "AI Assistent", icon: Sparkles, tid: "nav-ai-assistent", module: "AI Assistent" },
        ],
      },
    ];
  }

  const groups = [
    // === 1. OVERZICHT ===
    {
      cat: "Overzicht",
      icon: LayoutDashboard,
      items: [
        { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, tid: "nav-dashboard", module: "Dashboard" },
        { to: "/ai-assistent", label: "AI Assistent", icon: Sparkles, tid: "nav-ai-assistent", module: "AI Assistent" },
        ...(isManagerRole(role) ? [
          { to: "/beeldstudio", label: "Beeldstudio (AI)", icon: ImagePlus, tid: "nav-beeldstudio", module: "Beeldstudio (AI)", keywords: ["afbeelding", "beeld", "genereren", "nano banana", "illustratie", "marketing"] },
          { to: "/sync-health", label: "Sync Health", module: "Sync status", icon: Activity, tid: "nav-sync-health" },
          ...(role === "manager_plus" ? [{ to: "/instellingen", label: "Instellingen", icon: Settings2, tid: "nav-instellingen", keywords: ["instelling","termijn","norm","drempel","bewaartermijn","2fa","configuratie"] }] : []),
          { to: "/sync-overzicht", label: "Sync overzicht", module: "Sync status", icon: RefreshCw, tid: "nav-sync-overzicht", keywords: ["sync","synchroniseer","outsmart","zoho","bunq","revolut","mollie","offerte","factuur","relaties"] },
        ] : []),
      ],
    },
    // === 2. OPERATIE — met subgroepen (Klanten / Verkoop / Werk / Planning / Voertuigen & Voorraad) ===
    {
      cat: "Operatie",
      icon: Briefcase,
      items: [
        // --- Klanten (CRM) ---
        ...((isManagerRole(role) || heeftRol(role, "salesteam")) ? [
          { to: "/crm", label: "Relaties (CRM)", icon: HeartHandshake, tid: "nav-crm-klanten", module: "CRM", subgroup: "Klanten", keywords: ["klant","klanten","relatie","bedrijf","contactpersoon","adres"] },
          { to: "/vaste-klanten", label: "Vaste klanten", icon: Users2, tid: "nav-vaste-klanten", module: "Vaste klanten (leadopvolging)", subgroup: "Klanten", keywords: ["klant","lead","opvolging"] },
        ] : []),
        ...(isManagerRole(role) ? [
          { to: "/leads", label: "Leads in de buurt", icon: MapPin, tid: "nav-leads", module: "In de buurt (leads)", subgroup: "Klanten" },
        ] : []),
        // --- Verkoop (Offertes, Facturen, Contracten) ---
        ...((isManagerRole(role) || heeftRol(role, "salesteam")) ? [
          { to: "/offertes", label: "Offertes", icon: FileSignature, tid: "nav-offertes", module: "Offertes", subgroup: "Verkoop", keywords: ["offerte","aanbieding","prijsopgave","verkoop"] },
          { to: "/facturen", label: "Facturen", icon: Receipt, tid: "nav-facturen", module: "Facturen", subgroup: "Verkoop", keywords: ["factuur","facturatie","debiteuren","betaling","rekening"] },
        ] : []),
        ...((isManagerRole(role) || heeftRol(role, "kcc")) ? [
          { to: "/contracten", label: "Onderhoudscontracten", icon: ScrollText, tid: "nav-contracten", module: "Onderhoudscontracten", subgroup: "Verkoop", keywords: ["contract","onderhoud","abonnement","jaarlijks"] },
        ] : []),
        // --- Werk (Werkbonnen, Certificaten) ---
        ...((isManagerRole(role) || heeftRol(role, "salesteam")) ? [
          { to: "/werkbonnen", label: "Werkbonnen", icon: ClipboardCheck, tid: "nav-werkbonnen", counter: "werkbonnen", module: "Werkbonnen", subgroup: "Werk", keywords: ["werkbon","bon","outsmart","monteur","opdracht","klus"] },
          { to: "/onderhoudscertificaten", label: "Onderhoudscertificaten", icon: ShieldCheck, tid: "nav-onderhoudscertificaten", module: "Onderhoudscertificaten", subgroup: "Werk", keywords: ["certificaat","certificaten","reob","onderhoud","keuring"] },
          { to: "/preventiecertificaten", label: "Preventiecertificaten", icon: ShieldAlert, tid: "nav-preventiecertificaten", module: "Preventiecertificaten", subgroup: "Werk", keywords: ["certificaat","certificaten","preventie","keuring"] },
          { to: "/reob-rapporten", label: "REOB-rapporten", icon: ClipboardList, tid: "nav-reob-rapporten", module: "REOB-rapporten", subgroup: "Werk", keywords: ["reob","onderhoudsrapport","rtk","blusmiddelen","ccv","rapport"] },
        ] : []),
        // --- Planning ---
        ...(isManagerRole(role) ? [
          { to: "/planbord", label: "Planbord", icon: CalendarClock, tid: "nav-planbord", module: "Planbord", subgroup: "Planning", keywords: ["planning","rooster","agenda","inplannen"] },
        ] : []),
        ...(heeftRol(role, ["manager_plus", "manager", "teammanager", "kcc", "buitendienst_nl", "buitendienst_be"]) ? [
          { to: "/uitval-planner", label: "Uitval-planner", icon: Zap, tid: "nav-uitval-planner", module: "Uitval-planner", subgroup: "Planning" },
        ] : []),
        { to: "/agenda-dashboard", label: "Agenda-dashboard", icon: CalendarClock, tid: "nav-agenda-dashboard", module: "Agenda-dashboard", subgroup: "Planning" },
        { to: "/kalender", label: "Agenda sync", icon: CalendarClock, tid: "nav-kalender", module: "Kalender", subgroup: "Planning" },
        { to: "/taken", label: "Takenoverzicht", icon: ListChecks, tid: "nav-taken", counter: "taken_openstaand", module: "Taken", subgroup: "Planning" },
        // --- Voertuigen & Voorraad ---
        { to: "/assets", label: isManagerRole(role) ? "Assets" : "Mijn assets", icon: Car, tid: "nav-assets", module: "Assets", subgroup: "Voertuigen & Voorraad", keywords: ["voertuig","auto","gereedschap","kenteken","apk","bedrijfsmiddel","bus","telefoon","laptop"] },
        ...(isManagerRole(role) ? [
          { to: "/werkbus-overdracht", label: "Voertuig overdracht", icon: Truck, tid: "nav-werkbus-overdracht", module: "Werkbus-overdracht", parent: "/assets", subgroup: "Voertuigen & Voorraad" },
        ] : [
          { to: "/werkbus-overdracht", label: "Mijn voertuig-overdrachten", icon: Truck, tid: "nav-werkbus-overdracht", module: "Werkbus-overdracht", parent: "/assets", subgroup: "Voertuigen & Voorraad" },
        ]),
        { to: "/voorraad-teller", label: "Voorraad teller", icon: PackageSearch, tid: "nav-voorraad-teller", module: "Voorraad", subgroup: "Voertuigen & Voorraad" },
        { to: "/bestellingen", label: "Bestellingen", icon: ShoppingCart, tid: "nav-bestellingen", counter: "bestellingen_open", module: "Bestellingen", subgroup: "Voertuigen & Voorraad" },
        ...(heeftRol(role, ["manager_plus", "manager_operationeel", "kcc"]) ? [
          { to: "/verzendingen", label: "MyParcel verzendingen", icon: Truck, tid: "nav-verzendingen", module: "Verzendingen", subgroup: "Voertuigen & Voorraad" },
        ] : []),
      ],
    },
    // === 2b. PROJECTEN — BMI / BB / Aanbestedingen / Projecten ===
    {
      cat: "Projecten",
      icon: FolderKanban,
      items: [
        ...(isManagerRole(role) ? [
          { to: "/bmi-leads", label: "BMI-leads", icon: Flame, tid: "nav-bmi-leads", module: "BMI Leads", subgroup: "BMI · Brandmelder & Inbraak" },
          { to: "/projecten", label: "BB Projecten", icon: HardHat, tid: "nav-projecten", counter: "projecten", module: "Projecten BB", subgroup: "BB · Bouwbedrijf" },
          { to: "/bb-pipeline", label: "BB Pipeline (leads)", icon: Kanban, tid: "nav-bb-pipeline", module: "BB Pipeline", subgroup: "BB · Bouwbedrijf" },
          { to: "/bb-klanten", label: "BB Klantenlijst", icon: Building2, tid: "nav-bb-klanten", module: "BB Klantenlijst", subgroup: "BB · Bouwbedrijf" },
          { to: "/bb-followup", label: "BB Follow-up", icon: BarChart3, tid: "nav-bb-followup", module: "BB Follow-up", subgroup: "BB · Bouwbedrijf" },
          { to: "/bb-workflow", label: "BB Project-workflow", icon: Workflow, tid: "nav-bb-workflow", module: "BB Project-workflow", subgroup: "BB · Bouwbedrijf" },
          { to: "/bb-project-mails", label: "BB Project-mails", icon: MailQuestion, tid: "nav-bb-project-mails", module: "BB Project-mails", subgroup: "BB · Bouwbedrijf" },
          { to: "/bb-documenten", label: "BB Documenten", icon: FileText, tid: "nav-bb-documenten", module: "BB Documenten", subgroup: "BB · Bouwbedrijf", keywords: ["bb","bouwbedrijf","documenten","mappen","bestanden"] },
          { to: "/bb-materialen", label: "BB Materialen (Mulcol)", icon: Package, tid: "nav-bb-materialen", module: "Projecten BB", subgroup: "BB · Bouwbedrijf", keywords: ["materiaal","mulcol","catalogus","verbruik","materiaalstaat"] },
          { to: "/bb-onderaannemers", label: "BB Onderaannemers & overeenkomsten", icon: Handshake, tid: "nav-bb-onderaannemers", module: "Projecten BB", subgroup: "BB · Bouwbedrijf", keywords: ["onderaannemer","applicateur","overeenkomst","zzp","partner"] },
          { to: "/bb-onderaannemers?tab=overdrachten", label: "BB Overdrachtsdocumenten", icon: ClipboardList, tid: "nav-bb-overdrachten", module: "Projecten BB", subgroup: "BB · Bouwbedrijf", keywords: ["overdracht","overdrachtsdocument","onderaannemer","project"] },
          { to: "/partners", label: "Onderaannemers BB", module: "Partners (onderaannemers)", icon: Handshake, tid: "nav-partners", subgroup: "Onderaannemers BB", keywords: ["onderaannemer","partner","uitnodigen","portaal","offerte"] },
        ] : []),
        { to: "/aanbestedingen", label: "Aanbestedingen", icon: Briefcase, tid: "nav-aanbestedingen", module: "Aanbestedingen", subgroup: "Aanbestedingen", keywords: ["tender","aanbesteding","project","opdrachtgever"] },
        { to: "/bv-projecten", label: "Projecten", icon: FolderKanban, tid: "nav-bv-projecten", module: "Projecten", subgroup: "Projecten" },
      ],
    },
    // === 3. SPECIALISATIES — Ontruimingsplan ===
    {
      cat: "Specialisaties",
      icon: ClipboardCheck,
      items: [
        { to: "/ontruimingsplan", label: "Ontruimingsplan", icon: ClipboardCheck, tid: "nav-ontruiming", module: "Ontruimingsplan", subgroup: "Ontruimingsplan", keywords: ["nen 8112","plattegrond","vluchtplan","evacuatie","vluchtroute"] },
        { to: "/ontruimingsplan/plattegrond", label: "Plattegrond-canvas", icon: Map, tid: "nav-ontruiming-canvas", module: "Plattegrond-canvas", subgroup: "Ontruimingsplan" },
      ],
    },
    // === 4. FINANCIEEL — pure financiën (Inkomend / Uitgaand / Analyses). Offertes+Facturen zitten nu bij Operatie->Verkoop ===
    {
      cat: "Financieel",
      icon: Wallet,
      items: [
        ...(isManagerRole(role) ? [
          { to: "/inkomende-betalingen", label: "Inkomende betalingen", icon: ArrowDownToLine, tid: "nav-inkomende-betalingen", module: "Inkomende betalingen", subgroup: "Inkomend" },
          { to: "/contante-betalingen", label: "Contante betalingen", icon: Banknote, tid: "nav-contante-betalingen", module: "Contante betalingen", subgroup: "Inkomend", keywords: ["contant","cash","kas","keurmeester","afvoer","afgeleverd"] },
          { to: "/auto-boek-regels", label: "Auto-boek regels", icon: Zap, tid: "nav-auto-boek-regels", module: "Auto-boek regels", subgroup: "Inkomend" },
          { to: "/cash-flow", label: "Cash Flow", icon: TrendingUp, tid: "nav-cash-flow", module: "Cash Flow", subgroup: "Inkomend" },
          { to: "/debiteuren-kpi", label: "Debiteuren KPI", icon: TrendingUp, tid: "nav-debiteuren-kpi", module: "Debiteuren KPI", subgroup: "Inkomend" },
          { to: "/debiteurenbeheer", label: "Debiteurenbeheer (dossiers)", icon: FolderKanban, tid: "nav-debiteurenbeheer", module: "Debiteurenbeheer", subgroup: "Inkomend", keywords: ["debiteur","dossier","incasso","correspondentie","log","betalingsregeling","betaalcheck","kcc","emma"] },
          { to: "/whatsapp-herinneringen", label: "WhatsApp-herinneringen", icon: MessagesSquare, tid: "nav-whatsapp-herinneringen", module: "WhatsApp-herinneringen", subgroup: "Inkomend", keywords: ["whatsapp","incasso","herinnering","aanmaning","debiteur","sms"] },
          { to: "/belagent", label: "AI-belagent (Emma)", icon: PhoneCall, tid: "nav-belagent", module: "AI-belagent", subgroup: "Inkomend", keywords: ["bellen","belagent","emma","voice","debiteur","incasso","telefoon","elevenlabs"] },
          { to: "/crediteuren", label: "Crediteuren", icon: Package, tid: "nav-crediteuren", module: "Crediteuren", subgroup: "Uitgaand" },
          { to: "/crediteuren-inbox", label: "Crediteuren Inbox", icon: Inbox, tid: "nav-crediteuren-inbox", module: "Crediteuren Inbox", parent: "/crediteuren", subgroup: "Uitgaand" },
          { to: "/crediteur-workflow", label: "Crediteur-workflow", icon: CheckCircle2, tid: "nav-cred-wf", module: "Crediteur-workflow", subgroup: "Uitgaand" },
          { to: "/crediteur-betalingen", label: "SEPA-betalingen", icon: Landmark, tid: "nav-sepa", module: "SEPA-betalingen", subgroup: "Uitgaand" },
          { to: "/omzet-analytics", label: "Omzet analytics", icon: TrendingUp, tid: "nav-omzet-analytics", module: "Omzet analytics", subgroup: "Analyses" },
          { to: "/financials", label: "Financieel overzicht", icon: Wallet, tid: "nav-financieel", module: "Financieel", subgroup: "Analyses" },
        ] : [
          { to: "/contante-betalingen", label: "Contante betalingen", icon: Banknote, tid: "nav-contante-betalingen", module: "Contante betalingen", subgroup: "Inkomend", keywords: ["contant","cash","kas","keurmeester"] },
          { to: "/crediteur-workflow", label: "Crediteur-facturen uploaden", icon: Upload, tid: "nav-cred-wf", module: "Crediteur-workflow" },
        ]),
      ],
    },
    // === 4b. PERSONEELSZAKEN — samengevoegde categorie ===
    {
      cat: "Personeelszaken",
      icon: Calculator,
      items: isManagerRole(role) ? [
        { to: "/commissie", label: "Salaris en commissie berekening", icon: Calculator, tid: "nav-commissie-personeel", module: "Commissieberekening", keywords: ["commissie","provisie","loon","verdienst","instructie","ai-adviseur","salaris","berekening","maandafrekening","afrekening","configuratie","organisaties","eigen invoer","bptplus"] },
        { to: "/urenregels", label: "Urenregels", icon: Scale, tid: "nav-urenregels", module: "Urenregels", keywords: ["uren","pauze","regels","regelset","reistijd","overuren","contract","staffel"] },
        { to: "/uren-keuren", label: "Uren keuren", icon: ShieldCheck, tid: "nav-uren-keuren", module: "Uren keuren", keywords: ["uren","reiskosten","keuren","goedkeuren","hr","directeur","nmbrs","correctie","rapport","personeelsberekening","namens"] },
        { to: "/declaraties-keuren", label: "Declaraties keuren", icon: CheckCircle2, tid: "nav-declaraties-keuren", module: "Declaraties keuren", keywords: ["declaratie","declaraties","keuren","goedkeuren","nmbrs","onkosten","kleding","kledingbudget"] },
        { to: "/boetes", label: "Boetes", icon: ReceiptText, tid: "nav-boetes", module: "Boetes", keywords: ["boete","boetes","boeteregister","verkeersboete","cjib","kenteken","verrekenen","betaaltermijn"] },
        { to: "/periodieke-correctie", label: "Periodieke correctie", icon: RotateCcw, tid: "nav-periodieke-correctie", module: "Periodieke correctie", keywords: ["correctie","periodiek","nabetaling","inhouding","correctiedocument"] },
        { to: "/personeelszaken-overzicht", label: "Personeelsoverzicht (alles)", icon: LayoutGrid, tid: "nav-personeelszaken-overzicht", module: "Personeelsoverzicht", keywords: ["overzicht","archief","alles","samenvatting","integriteit","per medewerker","uren","boetes","declaraties","correcties","afrekeningen","nmbrs","excel"] },
        { to: "/mijn-uren", label: "Mijn uren", icon: Clock, tid: "nav-mijn-uren-mgr", module: "Mijn uren", keywords: ["uren","tijd","registratie","invoeren","urenbriefje"] },
        { to: "/mijn-reiskosten", label: "Mijn reiskosten", icon: Route, tid: "nav-mijn-reiskosten-mgr", module: "Mijn reiskosten", keywords: ["reiskosten","kilometers","km","ritten","reisvergoeding"] },
        { to: "/declaraties", label: "Declaraties", icon: Receipt, tid: "nav-declaraties-mgr", module: "Declaraties", keywords: ["declaratie","declaraties","onkosten","bon","bonnetje","kleding","parkeren","brandstof"] },
        { to: "/mijn-boetes", label: "Mijn boetes", icon: Car, tid: "nav-mijn-boetes-mgr", module: "Mijn boetes", keywords: ["boete","boetes","mijn boetes","verkeersboete"] },
        { to: "/mijn-commissie", label: "Mijn commissie", icon: Calculator, tid: "nav-mijn-commissie-mgr", module: "MijnCommissie" },
      ] : [
        { to: "/mijn-uren", label: "Mijn uren", icon: Clock, tid: "nav-mijn-uren-mw", module: "Mijn uren", keywords: ["uren","tijd","registratie","invoeren","urenbriefje"] },
        { to: "/mijn-reiskosten", label: "Mijn reiskosten", icon: Route, tid: "nav-mijn-reiskosten-mw", module: "Mijn reiskosten", keywords: ["reiskosten","kilometers","km","ritten","reisvergoeding"] },
        { to: "/declaraties", label: "Declaraties", icon: Receipt, tid: "nav-declaraties-mw", module: "Declaraties", keywords: ["declaratie","onkosten","bon","bonnetje"] },
        { to: "/mijn-boetes", label: "Mijn boetes", icon: Car, tid: "nav-mijn-boetes-mw", module: "Mijn boetes", keywords: ["boete","boetes","verkeersboete","cjib"] },
        { to: "/mijn-commissie", label: "Mijn commissie", icon: Calculator, tid: "nav-mijn-commissie", module: "MijnCommissie" },
      ],
    },
    // === 5. TEAM & HR — met subgroepen (Personeel / Persoonlijk / Opleidingen / Locatie) ===
    {
      cat: "Team & HR",
      icon: Users,
      items: [
        ...(isManagerRole(role) ? [
          { to: "/medewerkers", label: "Medewerkers", icon: Users, tid: "nav-medewerkers", module: "Medewerkers", subgroup: "Personeel", keywords: ["personeel","collega","dossier","hr","team","medewerker"] },
          { to: "/rechten", label: "Medewerkers & rechten", icon: KeyRound, tid: "nav-rechten", module: "Rol-permissies", subgroup: "Personeel", keywords: ["rechten","permissies","toegang","rollen","lezen","uitvoeren","beheren","wie mag wat","gebruikers","accounts","wachtwoord","2fa","login"] },
          { to: "/groepen", label: "Hiërarchie", icon: UsersRound, tid: "nav-hierarchie", module: "Hiërarchie", subgroup: "Personeel" },
        ] : [
          { to: "/mijn-gegevens", label: "Mijn gegevens", icon: UserCircle2, tid: "nav-mijn-gegevens", subgroup: "Persoonlijk" },
        ]),
        { to: "/mijn-handtekening", label: "Mijn handtekening", icon: PenLine, tid: "nav-signature", subgroup: "Persoonlijk" },
        { to: "/mijn-privacy-notities", label: "Mijn privacy-notities", icon: ShieldAlert, tid: "nav-mijn-privacy-notities", subgroup: "Persoonlijk" },
        ...(isManagerRole(role)
          ? [{ to: "/verlof", label: "Verlof", icon: PalmtreeIcon, tid: "nav-verlof", counter: "verlof_open", module: "Verlof", subgroup: "Personeel", keywords: ["vakantie","vrij","verlofaanvraag","afwezig","snipperdag"] }]
          : [{ to: "/verlof", label: "Mijn verlof", icon: PalmtreeIcon, tid: "nav-verlof", counter: "verlof_open", subgroup: "Persoonlijk", keywords: ["vakantie","vrij","verlofaanvraag","afwezig","snipperdag"] }]),
        ...(isManagerRole(role)
          ? [{ to: "/roosterkalender", label: "Kalender & feestdagen", icon: CalendarDays, tid: "nav-roosterkalender", module: "Kalender", subgroup: "Personeel", keywords: ["feestdagen","rooster","kalender","vrije dagen","kcc","buitendienst","turkije","ics"] }]
          : []),
        ...(isManagerRole(role)
          ? [{ to: "/meekijk", label: "Meekijkformulieren", module: "Meekijkformulieren", icon: ClipboardCheck, tid: "nav-meekijk", subgroup: "Personeel", keywords: ["meekijken","evaluatie","supervisor","keurmeester","beoordeling"] }]
          : [{ to: "/meekijk", label: "Mijn meekijkformulieren", module: "Meekijkformulieren", icon: ClipboardCheck, tid: "nav-meekijk", subgroup: "Persoonlijk" }]),
        { to: "/bekwaamheden", label: isManagerRole(role) ? "Bekwaamheden" : "Mijn bekwaamheden", icon: Award, tid: "nav-bekwaamheden", module: "Bekwaamheden", subgroup: isManagerRole(role) ? "Personeel" : "Persoonlijk", keywords: ["certificaat","diploma","vca","bekwaamheid","rijbewijs","reob","apragaz"] },
        { to: "/takenpakketten", label: "Takenpakketten", module: "Takenpakketten", icon: ListChecks, tid: "nav-takenpakketten", keywords: ["taken","takenpakket","functieomschrijving","rolbeschrijving","wie doet wat"], subgroup: isManagerRole(role) ? "Personeel" : "Persoonlijk" },
        { to: "/leenauto", label: "Leenauto", module: "Leenauto", icon: Car, tid: "nav-leenauto", keywords: ["leenauto","tesla","auto reserveren","poolauto","wagenpark"], subgroup: isManagerRole(role) ? "Personeel" : "Persoonlijk" },
        { to: "/activiteiten", label: "Bedrijfsactiviteiten", module: "Bedrijfsactiviteiten", icon: PartyPopper, tid: "nav-activiteiten", keywords: ["uitje","teamuitje","quiz","winactie","activiteit","borrel","feest","evenement","personeelsfeest"], subgroup: isManagerRole(role) ? "Personeel" : "Persoonlijk" },
        { to: "/cursussen", label: "Cursussen (NL/BE)", icon: BookOpen, tid: "nav-cursussen", module: "Training", keywords: ["cursus","training","opleiding","brandveiligheid","bhv","ehbo","elektro","nen","haspel"], subgroup: "Opleidingen" },
        ...(isManagerRole(role) ? [
          { to: "/opleidingscontracten", label: "Studieovereenkomsten", icon: FileSignature, tid: "nav-opleidingscontracten", module: "Opleidingscontracten", subgroup: "Opleidingen", keywords: ["studieovereenkomst","opleiding","contract","studiekosten"] },
        ] : []),
        { to: "/live-locatie", label: isManagerRole(role) ? "Live locatie team" : "Mijn locatie", module: "Live locatie", icon: MapPin, tid: "nav-live-locatie", keywords: ["locatie","gps","check-in","tracking","route","live","kaart","waar"], subgroup: "Locatie" },
        ...(isManagerRole(role) ? [
          { to: "/locatie-kaart", label: "Locatie-kaart", module: "Locatie-kaart", icon: Route, tid: "nav-locatie-kaart", keywords: ["kaart","route","map","gps-historie","medewerker-route"], subgroup: "Locatie" },
        ] : []),
      ],
    },
    // === 6. COMMUNICATIE & DOCS — met subgroepen (Meldingen / Overleg / Kennisbank) ===
    {
      cat: "Communicatie & Docs",
      icon: MessagesSquare,
      items: [
        { to: "/tickets", label: "Tickets", icon: MessagesSquare, tid: "nav-tickets", counter: "tickets", module: "Tickets", subgroup: "Meldingen", keywords: ["ticket","melding","storing","vraag","support"] },
        { to: "/klachten", label: "Klachten", icon: AlertOctagon, tid: "nav-klachten", counter: "klachten", module: "Klachten", subgroup: "Meldingen", keywords: ["klacht","ontevreden","escalatie"] },
        { to: "/meldingen", label: "Meldingen (meldknop)", icon: MessageSquareWarning, tid: "nav-meldingen", subgroup: "Meldingen", keywords: ["melding","fout","bug","verbetering","idee","vraag","meldknop"] },
        { to: "/beslissingen", label: "Mijn beslissingen", icon: Gavel, tid: "nav-beslissingen", subgroup: "Meldingen", keywords: ["beslissing","goedkeuren","akkoord","wacht op mij"] },
        ...(isManagerRole(role) ? [{ to: "/beoordelen", label: "Voorstellen beoordelen", icon: ListChecks, tid: "nav-beoordelen", subgroup: "Meldingen", keywords: ["herbeoordeling","ontdubbelen","twijfel","voorstel","sneltoets"] }] : []),
        { to: "/berichten", label: "Berichten", icon: MessageSquareText, tid: "nav-berichten", counter: "berichten_ongelezen", module: "Berichten", subgroup: "Meldingen" },
        { to: "/reminders", label: "Reminders", icon: Bell, tid: "nav-reminders", counter: "reminders_overtijd", module: "Reminders", subgroup: "Meldingen" },
        { to: "/verbeteringen", label: isManagerRole(role) ? "Verbeteringen" : "Verbetering melden", module: "Verbeteringen", icon: Lightbulb, tid: "nav-verbeteringen", counter: "verbeteringen", subgroup: "Meldingen" },
        { to: "/vergaderingen", label: "Vergaderingen", icon: CalendarDays, tid: "nav-vergaderingen", module: "Vergaderingen", subgroup: "Overleg" },
        { to: "/toolboxen", label: "Toolboxen (VCA)", icon: HardHat, tid: "nav-toolboxen", module: "Tickets", subgroup: "Overleg", keywords: ["toolbox","toolboxmeeting","veiligheid","vca","instructie","eenpager"] },
        ...((window.__bptFlags || {}).bijeenkomsten_v1 ? [{ to: "/bijeenkomsten", label: "Bijeenkomsten", icon: CalendarDays, tid: "nav-bijeenkomsten", module: "Bijeenkomsten", subgroup: "Overleg", keywords: ["bijeenkomst","toolbox","werkoverleg","vergadering","aanwezigheid","kam","reeks","herhalen"] }] : []),
        ...(isManagerRole(role) ? [
          { to: "/vergaderingen-plus", label: "Vergaderingen AI", icon: Sparkles, tid: "nav-vergaderingen-plus", module: "Vergaderingen AI", parent: "/vergaderingen", subgroup: "Overleg" },
          { to: "/postvak", label: "Postvak (inkomende mail)", icon: Inbox, tid: "nav-postvak", module: "Postvak", subgroup: "Overleg", keywords: ["postvak","inbox","inkomende mail","mail","logboek","imap","zoho"] },
          { to: "/mail-dashboard", label: "Mail-dashboard", icon: Inbox, tid: "nav-mail-dashboard", module: "Mail-dashboard", subgroup: "Overleg" },
          { to: "/bpt-inbox", label: "BPT Inbox (AI)", icon: Sparkles, tid: "nav-bpt-inbox", module: "BPT Inbox (AI)", subgroup: "Overleg", keywords: ["mail", "ai", "inbox", "verwerking", "bptplus"] },
        ] : []),
        { to: "/mail-volgsysteem", label: "Mail Volgsysteem", icon: Inbox, tid: "nav-mail-volgsysteem", module: "Mail Volgsysteem", subgroup: "Overleg", keywords: ["aanmeldingen","salesweb","inbox","aanvragen","mail"] },
        { to: "/overlegnotities", label: "Overlegnotities", icon: MessageSquareText, tid: "nav-overlegnotities", module: "Overlegnotities", subgroup: "Overleg" },
        { to: "/documenten", label: "Documenten", icon: FileText, tid: "nav-documenten", module: "Documenten", subgroup: "Kennisbank" },
        { to: "/handboek", label: "Handboek", icon: BookOpen, tid: "nav-handboek", module: "Handboek", subgroup: "Kennisbank" },
        ...(!isManagerRole(role) ? [{ to: "/mail-templates", label: "Mailsjablonen", icon: Mail, tid: "nav-mail-sjablonen", subgroup: "Kennisbank", keywords: ["sjabloon","mailsjabloon","template","herinnering","aanmaning","klacht","bevestiging"] }] : []),
        ...(role === "manager_plus" ? [{ to: "/rondleiding-beheer", label: "Rondleiding-beheer", icon: BookOpen, tid: "nav-rondleiding-beheer", module: "Handboek", subgroup: "Kennisbank", keywords: ["rondleiding","uitleg","handboek","ballon","tour","instructie"] }] : []),
        { to: "/snelkoppelingen", label: "Snelkoppelingen", icon: Link2, tid: "nav-links", module: "Snelkoppelingen", subgroup: "Kennisbank" },
        { to: "/locaties", label: "Vestigingen", icon: MapPin, tid: "nav-locaties", module: "Vestigingen", subgroup: "Kennisbank" },
        ...(isManagerRole(role) ? [
          { to: "/normschemas", label: "Normschema's (VCA/REOB/ISO)", module: "Handboek", icon: Award, tid: "nav-normschemas", keywords: ["vca","reob","iso","9001","14001","certificering","audit","eisen","norm","compliance"], subgroup: "Kennisbank" },
          { to: "/social-media", label: "Social Media Planner", module: "Social Media Planner", icon: Share2, tid: "nav-social-media", keywords: ["social","linkedin","instagram","tiktok","facebook","twitter","x","post","planner","marketing"], subgroup: "Kennisbank" },
          { to: "/seo-tool", label: "SEO & Vindbaarheid", module: "SEO & Vindbaarheid", icon: Globe2, tid: "nav-seo-tool", keywords: ["seo","geo","google","vindbaarheid","backlinks","zoekwoorden","pagespeed","snelheid","lokaal","content","audit"], subgroup: "Kennisbank" },
        ] : []),
      ],
    },
  ];

  if (isManagerRole(role)) {
    // === 7. SYSTEEM & AI (ICT, koppelingen, AI, analytics, permissies) ===
    groups.push({
      cat: "Systeem & AI",
      icon: ShieldPlus,
      items: [
        // Analytics
        { to: "/dashboards", label: "Uitgebreide dashboards", icon: BarChart3, tid: "nav-dashboards", module: "Uitgebreide dashboards", subgroup: "Analytics" },
        { to: "/mijn-dashboards", label: "Mijn dashboards", module: "Mijn dashboards", icon: LayoutDashboard, tid: "nav-mijn-dashboards", subgroup: "Analytics" },
        { to: "/ai-rapportages", label: "AI-Rapportages", icon: Sparkles, tid: "nav-ai-rapportages", module: "AI-Rapportages", subgroup: "Analytics" },
        { to: "/ai-instructies", label: "AI-instructies", icon: Sparkles, tid: "nav-ai-instr", module: "AI-instructies", subgroup: "Analytics" },
        // Beheer
        { to: "/beheer/bulk-invite", label: "Bulk-uitnodiging", icon: Send, tid: "nav-bulk-invite", module: "Bulk-uitnodiging", subgroup: "Beheer" },
        ...(role === "manager_plus" ? [
          { to: "/privacy-notities", label: "Privacy notities (directie)", module: "Privacy notities (directie)", icon: ShieldAlert, tid: "nav-privacy-notities", subgroup: "Beheer" },
          { to: "/systeemcontrole", label: "Systeemcontrole", icon: ShieldCheck, tid: "nav-systeemcontrole", module: "Systeembeheer", subgroup: "Beheer", keywords: ["controle","consistentie","synchroon","afwijkingen","kruiscontrole"] },
        ] : []),
        { to: "/admin-beheer", label: "Systeembeheer", icon: ShieldPlus, tid: "nav-admin-beheer", module: "Systeembeheer", subgroup: "Beheer" },
        { to: "/automations", label: "Automatiseringen", icon: Zap, tid: "nav-automations", module: "Automations", subgroup: "Beheer" },
        { to: "/audit-log", label: "Audit log", icon: History, tid: "nav-audit", module: "Audit log", subgroup: "Beheer" },
        { to: "/archief", label: "Archief", icon: Archive, tid: "nav-archief", module: "Archief (verwijderd)", subgroup: "Beheer" },
        { to: "/datakwaliteit", label: "Datakwaliteit & opschoning", icon: Database, tid: "nav-datakwaliteit", module: "Systeembeheer", subgroup: "Beheer", keywords: ["dubbel","dubbele","duplicaten","opschonen","datakwaliteit","controle","herstel","wat kan weg"] },
        // Integraties & ICT
        { to: "/ict-hub", label: "ICT · Health & Auto", icon: ShieldPlus, tid: "nav-ict-hub", module: "ICT", subgroup: "Integraties & ICT" },
        { to: "/koppelingen", label: "Koppelingen Hub", icon: Link2, tid: "nav-koppelingen", module: "Koppelingen Hub", subgroup: "Integraties & ICT" },
        { to: "/externe-toegang", label: "API-sleutels", icon: KeyRound, tid: "nav-api-sleutels", module: "Koppelingen Hub", subgroup: "Integraties & ICT", keywords: ["api","sleutel","key","token","extern","claude","zapier","integratie"] },
        { to: "/externe-toegang/docs", label: "API-documentatie", icon: BookOpen, tid: "nav-api-docs", module: "Koppelingen Hub", subgroup: "Integraties & ICT", keywords: ["api","docs","openapi","swagger","endpoints","handleiding"] },
        ...(role === "manager_plus" ? [{ to: "/ontwikkelen", label: "Ontwikkelen (Claude bouwt)", icon: Hammer, tid: "nav-ontwikkelen", module: "Koppelingen Hub", subgroup: "Integraties & ICT", keywords: ["ontwikkelen","claude","module","bouwen","goedkeuring","koppeling","mcp"] }] : []),
        { to: "/agent-control", label: "Agent Control", icon: Activity, tid: "nav-agent-control", module: "Agent Control", subgroup: "Integraties & ICT" },
        { to: "/outsmart-sync", label: "OutSmart sync", icon: RefreshCw, tid: "nav-outsmart-sync-ict", module: "ICT", subgroup: "Integraties & ICT" },
        { to: "/revolut", label: "Revolut", icon: CreditCard, tid: "nav-revolut", module: "Revolut", subgroup: "Integraties & ICT" },
        { to: "/bunq", label: "Bunq", icon: Landmark, tid: "nav-bunq", module: "Bunq-betalingen", subgroup: "Integraties & ICT" },
        { to: "/mypos", label: "MyPOS", icon: CreditCard, tid: "nav-mypos-fin", module: "MyPOS pin-transacties", subgroup: "Integraties & ICT" },
        { to: "/mollie", label: "Mollie", icon: Wallet, tid: "nav-mollie", module: "Mollie", subgroup: "Integraties & ICT" },
        // Mail & data
        { to: "/mail-templates", label: "Mail-templates", icon: Mail, tid: "nav-mail-templates", module: "Mail-templates", subgroup: "Mail & Data" },
        { to: "/handtekeningen", label: "Handtekeningen", icon: PenLine, tid: "nav-handtekeningen", module: "Handtekeningen", subgroup: "Mail & Data" },
        { to: "/crm-koppelingen", label: "CRM koppelingen", icon: Database, tid: "nav-crm", module: "CRM koppelingen", subgroup: "Mail & Data" },
        { to: "/data-migratie", label: "Data-migratie", icon: Database, tid: "nav-data-migratie", module: "Data-migratie", subgroup: "Mail & Data" },
        { to: "/extras", label: "Extras", icon: Sparkles, tid: "nav-extras", module: "Extras", subgroup: "Mail & Data" },
      ],
    });
  }

  return groups;
}


// Map van MODULES labels (AccountBeheer) → { to, icon, tid } — voor custom_permissies extra toegang
const MODULE_ROUTE_MAP = {
  "Dashboard": { to: "/dashboard", icon: LayoutDashboard, tid: "nav-dashboard" },
  "AI Assistent": { to: "/ai-assistent", icon: Sparkles, tid: "nav-ai-assistent" },
  "Medewerkers": { to: "/medewerkers", icon: Users, tid: "nav-medewerkers" },
  "Verlof": { to: "/verlof", icon: PalmtreeIcon, tid: "nav-verlof" },
  "Assets": { to: "/assets", icon: Car, tid: "nav-assets" },
  "Bekwaamheden": { to: "/bekwaamheden", icon: Award, tid: "nav-bekwaamheden" },
  "Tickets": { to: "/tickets", icon: MessagesSquare, tid: "nav-tickets" },
  "Klachten": { to: "/klachten", icon: AlertOctagon, tid: "nav-klachten" },
  "Vestigingen": { to: "/locaties", icon: MapPin, tid: "nav-locaties" },
  "Snelkoppelingen": { to: "/snelkoppelingen", icon: Link2, tid: "nav-links" },
  "Vergaderingen": { to: "/vergaderingen", icon: CalendarDays, tid: "nav-vergaderingen" },
  "Kalender": { to: "/kalender", icon: CalendarClock, tid: "nav-kalender" },
  "Training": { to: "/cursussen", icon: GraduationCap, tid: "nav-training" },
  "Ontruimingsplan": { to: "/ontruimingsplan", icon: ClipboardCheck, tid: "nav-ontruiming" },
  "Projecten BB": { to: "/projecten", icon: HardHat, tid: "nav-projecten" },
  "Documenten": { to: "/documenten", icon: FileText, tid: "nav-documenten" },
  "Bestellingen": { to: "/bestellingen", icon: ShoppingCart, tid: "nav-bestellingen" },
  "Voorraad": { to: "/voorraad-teller", icon: PackageSearch, tid: "nav-voorraad-teller" },
  "Financieel": { to: "/financials", icon: Wallet, tid: "nav-financieel" },
  "Commissieberekening": { to: "/commissie", icon: Calculator, tid: "nav-commissie" },
  "SEPA-betalingen": { to: "/crediteur-betalingen", icon: Landmark, tid: "nav-sepa" },
  "Bunq-betalingen": { to: "/bunq", icon: Landmark, tid: "nav-bunq" },
  "MyPOS pin-transacties": { to: "/mypos", icon: CreditCard, tid: "nav-mypos" },
  "Mollie": { to: "/mollie", icon: Wallet, tid: "nav-mollie" },
  "Inkomende betalingen": { to: "/inkomende-betalingen", icon: ArrowDownToLine, tid: "nav-inkomende-betalingen" },
  "Contante betalingen": { to: "/contante-betalingen", icon: Banknote, tid: "nav-contante-betalingen" },
  "CRM": { to: "/crm", icon: HeartHandshake, tid: "nav-crm-klanten" },
  "Werkbonnen": { to: "/werkbonnen", icon: ClipboardCheck, tid: "nav-werkbonnen" },
  "Planbord": { to: "/planbord", icon: CalendarClock, tid: "nav-planbord" },
  "Offertes & Facturen": { to: "/facturatie", icon: Wallet, tid: "nav-facturatie" },
  "Offertes": { to: "/offertes", icon: FileSignature, tid: "nav-offertes" },
  "Facturen": { to: "/facturen", icon: Receipt, tid: "nav-facturen" },
  "OutSmart sync": { to: "/outsmart-sync", icon: RefreshCw, tid: "nav-outsmart-sync" },
  "Onderhoudscontracten": { to: "/contracten", icon: ScrollText, tid: "nav-contracten" },
  "In de buurt (leads)": { to: "/leads", icon: MapPin, tid: "nav-leads" },
  "Crediteuren": { to: "/crediteuren", icon: Package, tid: "nav-crediteuren" },
  "BB Klantenlijst": { to: "/bb-klanten", icon: Building2, tid: "nav-bb-klanten" },
  "Vaste klanten (leadopvolging)": { to: "/vaste-klanten", icon: Users2, tid: "nav-vaste-klanten" },
  "Uitval-planner": { to: "/uitval-planner", icon: Zap, tid: "nav-uitval-planner" },
  "AI-instructies": { to: "/ai-instructies", icon: Sparkles, tid: "nav-ai-instr" },
  "Systeembeheer": { to: "/admin-beheer", icon: ShieldPlus, tid: "nav-admin-beheer" },
  "Mail-templates": { to: "/mail-templates", icon: Mail, tid: "nav-mail-templates" },
  "Archief (verwijderd)": { to: "/archief", icon: Archive, tid: "nav-archief" },
  "Audit log": { to: "/audit-log", icon: History, tid: "nav-audit" },
  "Berichten": { to: "/berichten", icon: MessageSquareText, tid: "nav-berichten" },
  "Taken": { to: "/taken", icon: ListChecks, tid: "nav-taken" },
  "Handboek": { to: "/handboek", icon: BookOpen, tid: "nav-handboek" },
  "Mijn uren & reiskosten": { to: "/mijn-uren", icon: Clock, tid: "nav-mijn-uren" },
  "Werkbus-overdracht": { to: "/werkbus-overdracht", icon: Truck, tid: "nav-werkbus" },
  "Verzendingen": { to: "/verzendingen", icon: Package, tid: "nav-verzendingen" },
  "Opleidingscontracten": { to: "/opleidingscontracten", icon: ScrollText, tid: "nav-opleidingscontracten" },
  "Overlegnotities": { to: "/overlegnotities", icon: PenLine, tid: "nav-overlegnotities" },
  "MijnCommissie": { to: "/mijn-commissie", icon: Calculator, tid: "nav-mijn-commissie" },
  "BMI Leads": { to: "/bmi-leads", icon: Flame, tid: "nav-bmi-leads" },
  "BB Pipeline": { to: "/bb-pipeline", icon: Kanban, tid: "nav-bb-pipeline" },
  "Mail-dashboard": { to: "/mail-dashboard", icon: Inbox, tid: "nav-mail-dashboard" },
  "Mail Volgsysteem": { to: "/mail-volgsysteem", icon: Inbox, tid: "nav-mail-volgsysteem" },
  "Aanbestedingen": { to: "/aanbestedingen", icon: Briefcase, tid: "nav-aanbestedingen" },
  "Data-migratie": { to: "/data-migratie", icon: Database, tid: "nav-data-migratie" },
  "Automations": { to: "/automations", icon: Zap, tid: "nav-automations" },
  "ICT": { to: "/ict-hub", icon: Cloud, tid: "nav-ict" },
  "Projecten": { to: "/bv-projecten", icon: FolderKanban, tid: "nav-bv-projecten" },
  "Reminders": { to: "/reminders", icon: Bell, tid: "nav-reminders" },
};

// Modules die restricted zijn tot BB-specialisatie-rollen. Zelfs als een junior gebruiker
// per ongeluk 'Projecten BB' in custom_permissies heeft staan, filtert deze list dat weg.
const BB_RESTRICTED_MODULES = new Set([
  "Projecten BB", "BB Follow-up", "BB Project-workflow", "BB Project-mails", "BB Pipeline", "BB Documenten", "BB Klantenlijst",
]);
const BB_TOEGESTANE_ROLLEN = new Set([...MANAGEMENT, "projectleider_pb", "kantoor", "kcc"]);

// Voegt modules toe die de gebruiker extra mag zien (custom_permissies + rol-matrix modules_lezen).
// Elk extra item wordt in zijn ECHTE categorie geplaatst (zoals in het manager-menu);
// alleen onbekende modules vallen terug op een "Extra toegang" categorie.
function applyExtraToegang(groups, customPermissies, modulesLezen, role) {
  if (role === "manager_plus") return groups; // Directeur ziet alles al
  const labels = new Set([...(customPermissies || []), ...(modulesLezen || [])]);
  if (labels.size === 0) return groups;
  const alreadyPaths = new Set();
  for (const g of groups) for (const it of g.items) alreadyPaths.add(it.to);
  const referentie = menuFor("manager_plus"); // volledige menustructuur = bron voor categorie & label
  const volgorde = referentie.map((r) => r.cat);
  const result = groups.map((g) => ({ ...g, items: [...g.items] }));
  const rest = [];
  const refItemVoor = (label) => {
    for (const g of referentie) {
      const it = g.items.find((i) => i.module === label);
      if (it) return it;
    }
    return null;
  };
  for (const label of labels) {
    if (BB_RESTRICTED_MODULES.has(label) && !BB_TOEGESTANE_ROLLEN.has(canon(role))) continue;
    // Module-label → menu-item: eerst via het volledige menu (alle 117 modules), anders via de vaste map
    const ref = refItemVoor(label);
    const meta = ref ? { to: ref.to, icon: ref.icon, tid: ref.tid } : MODULE_ROUTE_MAP[label];
    if (!meta || alreadyPaths.has(meta.to)) continue;
    alreadyPaths.add(meta.to);
    let geplaatst = false;
    for (const refGroep of referentie) {
      const refItem = refGroep.items.find((it) => it.to === meta.to);
      if (!refItem) continue;
      let doel = result.find((g) => g.cat === refGroep.cat);
      if (!doel) {
        doel = { cat: refGroep.cat, icon: refGroep.icon, items: [] };
        const eigenIdx = volgorde.indexOf(refGroep.cat);
        const idx = result.findIndex((g) => volgorde.indexOf(g.cat) > eigenIdx);
        if (idx === -1) result.push(doel); else result.splice(idx, 0, doel);
      }
      doel.items.push({ ...refItem });
      geplaatst = true;
      break;
    }
    if (!geplaatst) rest.push({ ...meta, label });
  }
  if (rest.length) {
    rest.sort((a, b) => a.label.localeCompare(b.label));
    result.push({ cat: "Extra toegang", icon: ShieldPlus, items: rest });
  }
  return result;
}

function CountBadge({ n }) {
  if (!n) return null;
  return (
    <span className="ml-auto inline-flex items-center justify-center h-5 min-w-[20px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold" data-testid="badge-count">
      {n > 99 ? "99+" : n}
    </span>
  );
}

function NavItemMetSnelActie({ it, idx, c, isChild, onSnelActie }) {
  const Icon = it.icon;
  const druk = useLangDruk(() => onSnelActie?.(it));
  return (
    <NavLink key={it.to + idx} to={it.to} data-testid={it.tid} {...(onSnelActie ? druk : {})}
      className={({ isActive }) =>
        `sidebar-link flex items-center gap-3 ${isChild ? "pl-12 py-1.5 text-[13px]" : "pl-8 py-2 text-sm"} pr-3 rounded-md transition-colors select-none ${
          isActive
            ? "bg-[hsl(var(--brand-blue))]/90 text-white font-medium border-l-4 border-[hsl(var(--bpt-red))] shadow-sm"
            : `${isChild ? "text-slate-500" : "text-slate-700"} hover:bg-slate-100 border-l-4 border-transparent`
        }`
      }>
      {isChild && <span className="text-slate-300 -ml-3 -mr-1 select-none">└</span>}
      <Icon className={isChild ? "h-3.5 w-3.5" : "h-4 w-4"} />
      <span className="truncate">{it.label}</span>
      <CountBadge n={c} />
    </NavLink>
  );
}

const SUB_DICHT_KEY = "bpt_subgroepen_dicht";
const leesSubDicht = () => { try { return new Set(JSON.parse(localStorage.getItem(SUB_DICHT_KEY) || "[]")); } catch { return new Set(); } };

function SubgroepHeader({ cat, sub, dicht, total, actief, onToggle, hubTo }) {
  return (
    <div className={`flex items-center pl-3 pr-2 pt-2 pb-1 rounded-md ${actief && dicht ? "bg-blue-50/70" : ""}`} data-testid={`sub-header-${cat}-${sub}`}>
      <button type="button" onClick={(e) => { e.stopPropagation(); onToggle(); }}
        className={`flex-1 min-w-0 flex items-center gap-1 text-[10px] uppercase tracking-wider font-semibold text-left transition-colors ${actief ? "text-blue-700" : "text-slate-500 hover:text-slate-800"}`}
        title={dicht ? `${sub} openen` : `${sub} insluiten`} aria-expanded={!dicht} data-testid={`sub-toggle-${cat}-${sub}`}>
        <ChevronDown className={`h-3 w-3 shrink-0 transition-transform ${dicht ? "-rotate-90" : ""}`} />
        <span className="truncate">{sub}</span>
        {dicht && total > 0 && <CountBadge n={total} />}
      </button>
      <NavLink to={hubTo || `/hub/${encodeURIComponent(cat)}/${encodeURIComponent(sub)}`} onClick={(e) => e.stopPropagation()}
        className="shrink-0 p-0.5 rounded text-slate-300 hover:text-[hsl(var(--brand-blue))] hover:bg-slate-100 transition-colors"
        title={`Bekijk overzicht: ${sub}`} data-testid={`hub-header-${cat}-${sub}`}>
        <ArrowUpRight className="h-3 w-3" />
      </NavLink>
    </div>
  );
}

function CategoryGroup({ group, counts, expanded, onToggle, onSnelActie }) {
  const CIcon = group.icon || LayoutDashboard;
  const isOpen = expanded;
  const groupTotal = group.items.reduce((sum, it) => sum + (it.counter ? (counts[it.counter] || 0) : 0), 0);
  const location = useLocation();
  const isActief = (it) => location.pathname === it.to || location.pathname.startsWith(it.to + "/");
  const hasActiveChild = group.items.some(isActief);
  const [subDicht, setSubDicht] = useState(leesSubDicht);
  const toggleSub = (key) => setSubDicht((d) => {
    const n = new Set(d); n.has(key) ? n.delete(key) : n.add(key);
    localStorage.setItem(SUB_DICHT_KEY, JSON.stringify([...n]));
    return n;
  });
  return (
    <div className="mb-1">
      <button onClick={(e) => { e.stopPropagation(); onToggle(); }}
        className={`w-full flex items-center gap-2 px-3 py-2 text-[11px] font-bold uppercase tracking-wider rounded-md transition-colors ${
          hasActiveChild
            ? "bg-blue-50 text-blue-700 border-l-2 border-blue-600"
            : isOpen
              ? "bg-slate-100 text-slate-800"
              : "bg-slate-50 text-slate-600 hover:bg-slate-100 hover:text-slate-800"
        }`}
        data-testid={`cat-${group.cat.replace(/\s/g, "-").toLowerCase()}`}>
        <CIcon className="h-3.5 w-3.5" />
        <span className="flex-1 text-left">{group.cat}</span>
        {groupTotal > 0 && <CountBadge n={groupTotal} />}
        <ChevronDown className={`h-3.5 w-3.5 transition-transform ${isOpen ? "" : "-rotate-90"}`} />
      </button>
      {isOpen && (
        <div className="space-y-0.5">
          {(() => {
            // v2.2 — Render met subgroep-headers (items met dezelfde `subgroup` staan bij elkaar); v2.3 — subgroep in-/uitklapbaar met 1 klik
            const out = [];
            let lastSub = null;
            group.items.forEach((it, idx) => {
              const subKey = it.subgroup ? `${group.cat}/${it.subgroup}` : null;
              if (it.subgroup && it.subgroup !== lastSub) {
                const subItems = group.items.filter((x) => x.subgroup === it.subgroup);
                out.push(
                  <SubgroepHeader key={`sub-${idx}`} cat={group.cat} sub={it.subgroup} dicht={subDicht.has(subKey)}
                    total={subItems.reduce((s, x) => s + (x.counter ? (counts[x.counter] || 0) : 0), 0)}
                    actief={subItems.some(isActief)} onToggle={() => toggleSub(subKey)} />
                );
                lastSub = it.subgroup;
              } else if (!it.subgroup) {
                lastSub = null;
              }
              if (subKey && subDicht.has(subKey)) return;
              const c = it.counter ? counts[it.counter] || 0 : 0;
              const isChild = !!it.parent;
              out.push(<NavItemMetSnelActie key={it.to + idx} it={{ ...it, cat: it.cat || group.cat }} idx={idx} c={c} isChild={isChild} onSnelActie={onSnelActie} />);
            });
            return out;
          })()}
        </div>
      )}
    </div>
  );
}

/** Bouwsteen (domein) in het zijmenu: rij = naar startpagina; alleen de actieve bouwsteen staat open (chevron klapt handmatig open/dicht). */
function DomeinGroup({ group, counts, expanded, actief, onToggle, onSnelActie }) {
  const nav = useNavigate();
  const location = useLocation();
  const CIcon = group.icon || LayoutDashboard;
  const groupTotal = group.items.reduce((sum, it) => sum + (it.counter ? (counts[it.counter] || 0) : 0), 0);
  const isActief = (it) => location.pathname === it.to.split("?")[0] || location.pathname.startsWith(it.to.split("?")[0] + "/");
  const [subDicht, setSubDicht] = useState(leesSubDicht);
  const toggleSub = (key) => setSubDicht((d) => {
    const n = new Set(d); n.has(key) ? n.delete(key) : n.add(key);
    localStorage.setItem(SUB_DICHT_KEY, JSON.stringify([...n]));
    return n;
  });
  const opHub = location.pathname === group.hubTo;
  return (
    <div className="mb-0.5" data-testid={`domein-${group.key}`}>
      <div className={`flex items-center rounded-md transition-colors ${actief ? "bg-[hsl(var(--brand-blue))]/10 text-blue-800" : "text-slate-700 hover:bg-slate-100"}`}>
        <button onClick={(e) => { e.stopPropagation(); nav(group.hubTo); }}
          className={`flex-1 min-w-0 flex items-center gap-2.5 pl-3 pr-1 py-2 text-[13px] font-semibold text-left ${opHub ? "text-[hsl(var(--brand-red))]" : ""}`}
          data-testid={`domein-knop-${group.key}`} title={`Startpagina ${group.cat}`}>
          <span className={`h-6 w-6 rounded-md ${group.kleur || "bg-slate-600"} text-white flex items-center justify-center shrink-0`}><CIcon className="h-3.5 w-3.5" /></span>
          <span className="truncate flex-1">{group.cat}</span>
          {groupTotal > 0 && <CountBadge n={groupTotal} />}
        </button>
        <button onClick={(e) => { e.stopPropagation(); onToggle(); }} className="p-2 text-slate-400 hover:text-slate-700" aria-expanded={expanded} aria-label={expanded ? "Inklappen" : "Uitklappen"} data-testid={`domein-toggle-${group.key}`}>
          <ChevronDown className={`h-3.5 w-3.5 transition-transform ${expanded ? "" : "-rotate-90"}`} />
        </button>
      </div>
      {expanded && (
        <div className="space-y-0.5 pb-1">
          {(() => {
            const out = [];
            let lastSub = null;
            group.items.forEach((it, idx) => {
              const subKey = it.subgroup ? `${group.key}/${it.subgroup}` : null;
              if (it.subgroup && it.subgroup !== lastSub) {
                const subItems = group.items.filter((x) => x.subgroup === it.subgroup);
                out.push(
                  <SubgroepHeader key={`sub-${idx}`} cat={group.cat} sub={it.subgroup} dicht={subDicht.has(subKey)} hubTo={`${group.hubTo}?zoek=${encodeURIComponent(it.subgroup)}`}
                    total={subItems.reduce((s, x) => s + (x.counter ? (counts[x.counter] || 0) : 0), 0)}
                    actief={subItems.some(isActief)} onToggle={() => toggleSub(subKey)} />
                );
                lastSub = it.subgroup;
              } else if (!it.subgroup) {
                lastSub = null;
              }
              if (subKey && subDicht.has(subKey)) return;
              const c = it.counter ? counts[it.counter] || 0 : 0;
              out.push(<NavItemMetSnelActie key={it.to + idx} it={{ ...it, cat: group.cat }} idx={idx} c={c} isChild={!!it.parent} onSnelActie={onSnelActie} />);
            });
            return out;
          })()}
        </div>
      )}
    </div>
  );
}

// Filter menu-items strikt op modules_lezen (behalve applicateur die zijn eigen minimale menu al krijgt)
function filterByPermissies(groups, permissies, role) {
  if (!permissies) return groups; // still loading
  if (role === "manager_plus") return groups; // Directeur ziet alles
  const allowed = new Set(permissies.modules_lezen || []);
  const result = [];
  for (const g of groups) {
    // Items zonder 'module' key (bv. /mijn-gegevens, /verbeteringen) blijven altijd zichtbaar
    const items = (g.items || []).filter(it => !it.module || allowed.has(it.module));
    if (items.length > 0) result.push({ ...g, items });
  }
  return result;
}

// Top-level component (stabiel over re-renders — voorkomt remount/focusverlies van het zoekveld)
function SidebarContent({ groups, alleGroups, favorieten, verborgen, onHerstel, onMenuInstellingen, onSnelActie, counts, expanded, onToggleCat, user, onLogout, onNavigate, inSheet, actiefDomein }) {
  return (
    <div className={`flex flex-col bg-white ${inSheet ? "flex-1 min-h-0" : "h-full"}`} data-testid={inSheet ? "sidebar-mobiel" : "sidebar"}>
      <NavLink to="/dashboard" onClick={onNavigate} className="p-4 border-b border-border flex flex-col items-center justify-center gap-1.5" data-testid="sidebar-home-link" title="Naar dashboard">
        <img
          src="/icon-192.png"
          alt="BPT"
          className="h-14 w-14 rounded-2xl shadow-sm"
          data-testid="sidebar-logo"
        />
        <div className="text-[10px] font-bold tracking-[0.14em] text-slate-800 text-center leading-tight uppercase">
          Brand Preventie<br />Techniek
        </div>
        <div className="text-[11px] font-extrabold tracking-widest text-[hsl(var(--brand-red))] uppercase" data-testid="app-name">BPTplus</div>
      </NavLink>
      <nav className="flex-1 overflow-y-auto py-3 px-2" onClick={onNavigate}>
        <MenuZoeker hubs={groups} donker={false} onNavigate={onNavigate} />
        {favorieten?.length > 0 && (
          <CategoryGroup group={{ cat: "Favorieten", icon: Star, items: favorieten.map((f) => ({ ...f, subgroup: undefined, parent: undefined, tid: `fav-${f.tid}` })) }}
            counts={counts} expanded={expanded["Favorieten"] !== false} onToggle={() => onToggleCat("Favorieten")} onSnelActie={onSnelActie} />
        )}
        <div className="px-3 pt-2 pb-1 text-[10px] uppercase tracking-wider font-semibold text-slate-400" data-testid="sidebar-bouwstenen-kop">Hubs</div>
        {groups.map((g) => (
          <DomeinGroup key={g.key} group={g} counts={counts}
            expanded={expanded[g.key] === undefined ? g.key === actiefDomein : expanded[g.key]}
            actief={g.key === actiefDomein}
            onToggle={() => onToggleCat(g.key)}
            onSnelActie={onSnelActie}
          />
        ))}
        <VerborgenMenu verborgen={verborgen || []} onHerstel={onHerstel} onInstellingen={onMenuInstellingen} />
      </nav>
      <div className="border-t border-border p-3">
        <div className="px-2 py-2 flex items-center gap-3">
          <div className="h-8 w-8 rounded-full bg-slate-200 flex items-center justify-center text-slate-700 text-sm font-semibold">
            {(user?.name || "?").slice(0, 1).toUpperCase()}
          </div>
          <div className="min-w-0">
            <div className="text-sm font-medium truncate" data-testid="current-user-name">{user?.name}</div>
            <div className="overline">{rolLabel(user?.role)}</div>
          </div>
        </div>
        <LayoutV2Schakelaar />
        <LayoutV3Knop />
        <NavLink to="/alle-tools" onClick={onNavigate} className="flex items-center w-full px-3 py-1.5 rounded-md text-sm text-slate-600 hover:text-slate-900 hover:bg-slate-100" data-testid="sidebar-alle-tools-link">
          <LayoutGrid className="h-4 w-4 mr-2" /> Alle tools
        </NavLink>
        <Button variant="ghost" size="sm" className="w-full justify-start text-slate-600 hover:text-slate-900" onClick={onMenuInstellingen} data-testid="menu-aanpassen-mobiel-btn" data-rechten="lezen">
          <Settings2 className="h-4 w-4 mr-2" /> Menu aanpassen
        </Button>
        <Button variant="ghost" size="sm" className="w-full justify-start text-slate-600 hover:text-slate-900" onClick={onLogout} data-testid="logout-btn">
          <LogOut className="h-4 w-4 mr-2" /> Uitloggen
        </Button>
      </div>
    </div>
  );
}

export default function Layout({ children }) {
  const { user, logout, permissies } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const { verplaatsingen } = useMenuIndeling();
  const dyn = useDynModules(user);
  const alleGroups = React.useMemo(() => [...menuVoorGebruiker(user, permissies), ...dyn.groups], [user, permissies, dyn.groups]);
  const [voorkeuren, setVoorkeuren] = useState(LEGE_VOORKEUREN);
  const [menuDialoog, setMenuDialoog] = useState(false);
  const { zichtbaar: catGroups, verborgen, favorieten } = React.useMemo(() => pasVoorkeurenToe(alleGroups, voorkeuren), [alleGroups, voorkeuren]);
  const groups = React.useMemo(() => naarDomeinen(catGroups, { ...dyn.hubs, ...verplaatsingen }, menuFor("manager_plus")), [catGroups, verplaatsingen, dyn.hubs]);
  const actiefDomein = React.useMemo(() => domeinVoorPad(groups, location.pathname), [groups, location.pathname]);
  const [counts, setCounts] = useState({});
  const [expanded, setExpanded] = useState({});
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openHub, setOpenHub] = useState(null);
  const [meerOpen, setMeerOpen] = useState(false);
  const [balkDicht, setBalkDicht] = useState(() => localStorage.getItem("bpt_hub_bar_collapsed") === "1");
  const balkRef = React.useRef(null);
  const toggleBalk = () => setBalkDicht((d) => { localStorage.setItem("bpt_hub_bar_collapsed", d ? "0" : "1"); return !d; });
  const toggleFavoriet = (it) => {
    const fav = voorkeuren.favorieten.includes(it.to) ? voorkeuren.favorieten.filter((k) => k !== it.to) : [...voorkeuren.favorieten, it.to];
    bewaarVoorkeuren({ ...voorkeuren, favorieten: fav }).catch(() => {});
  };

  useEffect(() => {
    if (!user?.id) return;
    const laad = () => api.get("/mijn/menu-voorkeuren").then(({ data }) => setVoorkeuren({ ...LEGE_VOORKEUREN, ...data })).catch(() => {});
    laad();
    window.addEventListener("bpt:menu-voorkeuren", laad);
    return () => window.removeEventListener("bpt:menu-voorkeuren", laad);
  }, [user?.id]);
  const bewaarVoorkeuren = async (vk) => {
    const { data } = await api.put("/mijn/menu-voorkeuren", vk);
    setVoorkeuren({ ...LEGE_VOORKEUREN, ...data });
  };
  const herstelVoorkeuren = async () => {
    await api.delete("/mijn/menu-voorkeuren");
    setVoorkeuren(LEGE_VOORKEUREN);
  };
  const herstelOnderdeel = (soort, key) => {
    const veld = { categorie: "verborgen_categorieen", subgroep: "verborgen_subgroepen", item: "verborgen_items" }[soort];
    bewaarVoorkeuren({ ...voorkeuren, [veld]: voorkeuren[veld].filter((k) => k !== key) }).catch(() => {});
  };
  const [snelItem, setSnelItem] = useState(null);
  const snelFavoriet = () => {
    const fav = voorkeuren.favorieten.includes(snelItem.to) ? voorkeuren.favorieten.filter((k) => k !== snelItem.to) : [...voorkeuren.favorieten, snelItem.to];
    bewaarVoorkeuren({ ...voorkeuren, favorieten: fav }).catch(() => {});
    setSnelItem(null);
  };
  const snelVerberg = () => {
    bewaarVoorkeuren({ ...voorkeuren, verborgen_items: voorkeuren.verborgen_items.includes(snelItem.to) ? voorkeuren.verborgen_items : [...voorkeuren.verborgen_items, snelItem.to] }).catch(() => {});
    setSnelItem(null);
  };

  useEffect(() => {
    // Nieuwe route → alleen de actieve bouwsteen open (handmatige toggles vervallen)
    setExpanded({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.role, permissies, actiefDomein]);

  useEffect(() => {
    // Fetch notification counters (open items per module)
    const fetchCounts = async () => {
      try { const { data } = await api.get("/notifications/counts"); setCounts(data); } catch {}
    };
    fetchCounts();
    const iv = setInterval(fetchCounts, 60000); // elke minuut refresh
    return () => clearInterval(iv);
  }, [user?.id]);

  // Sluit mobile drawer en hub-paneel bij route wissel
  useEffect(() => { setMobileOpen(false); setOpenHub(null); setMeerOpen(false); }, [location.pathname, location.search]);

  const onLogout = async () => { await logout(); nav("/login"); };
  const onToggleCat = (cat) => setExpanded((e) => {
    const huidig = e[cat] === undefined ? (cat === actiefDomein || cat === "Favorieten") : e[cat];
    return { ...e, [cat]: !huidig };
  });
  const sidebarProps = { groups, alleGroups, favorieten, verborgen, onHerstel: herstelOnderdeel, onMenuInstellingen: () => { setMobileOpen(false); setMenuDialoog(true); },
                         onSnelActie: (it) => setSnelItem(it), counts, expanded, onToggleCat, user, onLogout, actiefDomein };
  const v3 = useLayoutV3();
  const sluitHub = React.useCallback(() => setOpenHub(null), []);
  const sluitMeer = React.useCallback(() => setMeerOpen(false), []);
  const telefoon = useSmal(640);
  useTabelKaarten(v3.actief && telefoon);

  const overlays = (
    <>
      {/* PWA install banner (Chrome/Android/iOS) */}
      <PWAInstallPrompt />
      {/* Onboarding wizard — alleen bij 1e login voor echte email-domains */}
      <OnboardingWizard />
      {/* Verplichte noodcontact-invoer + ID-document verzoek */}
      <NoodcontactModal />
      <IdVerzoekModal />
      <MilestoneCelebration />
      <WelkomOverlay />
      {/* Global Cmd-K / Ctrl-K search palette */}
      <GlobalSearch />
      {/* Persoonlijke menu-indeling (per account) */}
      <MenuInstellingenDialoog open={menuDialoog} onClose={() => setMenuDialoog(false)} groups={alleGroups}
        voorkeuren={voorkeuren} onSave={bewaarVoorkeuren} onReset={herstelVoorkeuren} />
      <MenuSnelActie item={snelItem} isFavoriet={!!snelItem && voorkeuren.favorieten.includes(snelItem.to)} onFavoriet={snelFavoriet} onVerberg={snelVerberg}
        onInstellingen={() => { setSnelItem(null); setMobileOpen(false); setMenuDialoog(true); }} onClose={() => setSnelItem(null)} />
      <LocatieTracker />
      <FloatingVoiceAssistant />
      <MeldKnop />
      <RondleidingKnop />
      <PdfViewer />
      <WatIsNieuw />
    </>
  );

  const inhoud = (
    <>
      <TestomgevingBanner />
      <AlleenLezenBalk />
      <GeenToegangBalk />
      <div className="mb-2 flex justify-end"><WerkveldSchakelaar compact /></div>
      <div className="module-inhoud">{children}</div>
    </>
  );

  if (v3.actief) {
    const paneelHub = openHub && groups.find((g) => g.key === openHub);
    return (
      <div className="v3-app" data-testid="app-shell" data-layout="v3">
        <V3Rail hubs={groups} counts={counts} actiefDomein={actiefDomein} openHub={openHub} onHub={(k) => setOpenHub((o) => (o === k ? null : k))} thema={v3.thema} onThema={v3.wisselThema} />
        {paneelHub && <V3HubPaneel hub={paneelHub} counts={counts} onClose={sluitHub} />}
        <div className="v3-main">
          <V3TopBar hubs={groups} user={user} onMenuInstellingen={() => setMenuDialoog(true)} onLogout={onLogout} />
          <main className="v3-content prevent-overflow-x" data-testid="v3-content">{inhoud}</main>
        </div>
        {telefoon && meerOpen && <V3MeerSheet hubs={groups} counts={counts} actiefDomein={actiefDomein} onClose={sluitMeer} thema={v3.thema} onThema={v3.wisselThema} />}
        {telefoon && <V3BottomNav hubs={groups} meerOpen={meerOpen} onMeer={setMeerOpen} />}
        {overlays}
      </div>
    );
  }

  return (
    <div className="min-h-screen flex" data-testid="app-shell">
      {/* Desktop (lg+): donkere hub-balk + uitklappaneel (HubSpot-achtig) */}
      <HubBar barRef={balkRef} hubs={groups} counts={counts} actiefDomein={actiefDomein} openHub={openHub} onHub={(k) => setOpenHub((o) => (o === k ? null : k))}
        favorieten={favorieten} collapsed={balkDicht} onToggleCollapsed={toggleBalk} onMenuInstellingen={() => setMenuDialoog(true)} user={user} onLogout={onLogout} onSnelActie={(it) => setSnelItem(it)} />
      {openHub && groups.find((g) => g.key === openHub) && (
        <HubFlyout hub={groups.find((g) => g.key === openHub)} counts={counts} favorieten={favorieten} onFavoriet={toggleFavoriet} onClose={() => setOpenHub(null)}
          left={balkDicht ? 68 : 240} barRef={balkRef} onSnelActie={(it) => setSnelItem(it)} />
      )}

      {/* Mobile/iPad top bar met hamburger */}
      <div className="lg:hidden fixed top-0 inset-x-0 z-30 bg-white/95 backdrop-blur-md border-b border-border safe-top">
        <div className="h-14 flex items-center justify-between px-3 safe-x">
          <div className="flex items-center gap-0.5">
            <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="sm" className="p-2 icon-btn" data-testid="mobile-menu-btn" aria-label="Menu openen">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="left" className="w-72 p-0 max-w-[85vw] safe-top safe-bottom flex flex-col [&>div:last-child]:mx-0 [&>div:last-child]:mt-0">
                <SheetTitle className="sr-only">Hoofdmenu</SheetTitle>
                <SheetDescription className="sr-only">Navigatiemenu met alle beschikbare pagina&apos;s voor uw rol</SheetDescription>
                <SidebarContent {...sidebarProps} onNavigate={() => setMobileOpen(false)} inSheet />
              </SheetContent>
            </Sheet>
            {location.pathname !== "/dashboard" && (
              <Button variant="ghost" size="sm" className="p-2 icon-btn shrink-0" data-testid="mobile-back-btn" data-terugknop="1" aria-label="Terug"
                onClick={() => (window.history.length > 2 ? nav(-1) : nav("/dashboard"))}>
                <ArrowLeft className="h-5 w-5" />
              </Button>
            )}
          </div>
          <button className="flex items-center gap-2" data-testid="mobile-home-logo" aria-label="Naar dashboard"
            onClick={() => nav("/dashboard")}>
            <img src="/icon-192.png" alt="BPT" className="h-8 w-8 rounded-lg" />
            <span className="text-sm font-bold tracking-wider text-[hsl(var(--brand-red))] hidden sm:inline">BPTplus</span>
          </button>
          <div className="flex items-center gap-1.5">
            <Button variant="ghost" size="sm" className="p-2 icon-btn" data-testid="mobile-search-btn" aria-label="Zoeken"
              onClick={() => window.dispatchEvent(new Event("bpt:open-cmdk"))}>
              <SearchIcon className="h-5 w-5" />
            </Button>
            <MobileRolPill user={user} />
            <MeldingenCentrum variant="mobile" />
            <div className="h-8 w-8 rounded-full bg-slate-200 flex items-center justify-center text-slate-700 text-xs font-semibold" data-testid="mobile-user-avatar">
              {(user?.name || "?").slice(0, 1).toUpperCase()}
            </div>
          </div>
        </div>
      </div>

      <main className="flex-1 min-w-0 pt-14 lg:pt-0 pb-16 md:pb-0 safe-x bg-slate-50/60">
        <TopBar hubs={groups} user={user} onMenuInstellingen={() => setMenuDialoog(true)} onLogout={onLogout} onHub={(k) => setOpenHub((o) => (o === k ? null : k))} />
        <div className="max-w-[1536px] mx-auto p-3 sm:p-4 md:p-6 lg:p-8 lg:pt-6 prevent-overflow-x">{inhoud}</div>
      </main>

      {/* Mobile bottom tab bar (< md) — favorieten van de gebruiker */}
      <MobileTabBar onMenuClick={() => setMobileOpen(true)} favorieten={favorieten} />
      {overlays}
    </div>
  );
}

/** Kleine rol-badge rechtsboven op elke pagina (desktop) — Optie A privé-login vervolg */
function RolBadge({ user }) {
  if (!user) return null;
  const info = WELKOM_ROLE_INFO[canon(user.role)] || WELKOM_ROLE_INFO.medewerker;
  const Icon = info.icon;
  return (
    <div
      className="pointer-events-auto inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/95 backdrop-blur-sm border border-border shadow-sm text-xs"
      title={`${user.name} · ${info.label}`}
      data-testid="topbar-rol-badge"
    >
      <span
        className="h-6 w-6 rounded-full flex items-center justify-center text-white text-[10px] font-heading font-bold shrink-0"
        style={{ background: info.accent }}
        data-testid="topbar-avatar"
      >
        {initialsFrom(user.name)}
      </span>
      <span className="hidden xl:inline text-slate-700 font-medium truncate max-w-[140px]">{user.name}</span>
      <span
        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full font-semibold text-white"
        style={{ background: info.accent }}
      >
        <Icon className="h-3 w-3" />
        <span className="truncate max-w-[180px]">{info.label}</span>
      </span>
    </div>
  );
}

/** Compact mobile rol-badge (alleen icoon + verkorte rol-tekst) */
function MobileRolPill({ user }) {
  if (!user) return null;
  const info = WELKOM_ROLE_INFO[canon(user.role)] || WELKOM_ROLE_INFO.medewerker;
  const Icon = info.icon;
  // Verkorte label voor smalle schermen
  const shortLabel = (info.label || "")
    .replace(" — Operationeel Directeur", "")
    .replace(" Operationeel", " Ops")
    .replace(" Bedrijfsvoering", " BV")
    .replace(" Brandveiligheid", " BV+")
    .replace("Buitendienst ", "Buitend. ")
    .replace("Projectleider Passieve Brandveiligheid", "Projectleider BB")
    .slice(0, 18);
  return (
    <div
      className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-white text-[10px] font-semibold shrink-0"
      style={{ background: info.accent }}
      title={`${user.name} · ${info.label}`}
      data-testid="mobile-rol-pill"
    >
      <Icon className="h-3 w-3 shrink-0" />
      <span className="hidden xs:inline truncate max-w-[100px]">{shortLabel}</span>
    </div>
  );
}

// v2.2 — Export for SubgroepHub page: haal menu-groups op voor een rol
export function buildMenuGroups(role) {
  return menuFor(role);
}

/** Referentiemenu (alles) — bepaalt voor elke rol in welke bouwsteen/groep een pagina standaard hoort. */
export const referentieMenu = () => menuFor("manager_plus");

/** Volledige menu-groepen (categorieën) waar deze gebruiker bij mag: rol-menu + rechtenmatrix + extra toegang. */
export function menuVoorGebruiker(user, permissies) {
  const filtered = filterByPermissies(menuFor(user?.role), permissies, user?.role);
  return applyExtraToegang(filtered, user?.custom_permissies, permissies?.modules_lezen, user?.role);
}

// Module-label dat bij een frontend-route hoort (menu-items van alle rollen + MODULE_ROUTE_MAP). Langste prefix wint.
let _padModuleCache = null;
export function moduleVoorPad(pathname) {
  if (!_padModuleCache) {
    const map = {};
    const rollen = ["manager_plus", "manager", "teammanager", "kcc", "buitendienst_nl", "salesteam", "projectleider_pb", "applicateur"];
    rollen.forEach((r) => menuFor(r).forEach((g) => (g.items || []).forEach((it) => { if (it.to && it.module && !map[it.to]) map[it.to] = it.module; })));
    Object.entries(MODULE_ROUTE_MAP).forEach(([mod, m]) => { if (m?.to && !map[m.to]) map[m.to] = mod; });
    _padModuleCache = map;
  }
  const pad = (pathname || "").split("?")[0].replace(/\/$/, "");
  const kandidaten = Object.keys(_padModuleCache).filter((to) => pad === to || pad.startsWith(to + "/")).sort((a, b) => b.length - a.length);
  return kandidaten.length ? _padModuleCache[kandidaten[0]] : null;
}

// Gele balk bovenaan elke module waar de gebruiker wél mag kijken maar niet wijzigen + body-klasse voor generieke knop-verberging.
// Crawl 19-10: pagina's die via URL bereikbaar zijn maar waarvan de gegevens 403 geven, toonden een lege pagina.
// Eén balk per pagina met de reden van de server; verdwijnt bij navigatie. Geen rechtenwijziging — alleen uitleg.
function GeenToegangBalk() {
  const location = useLocation();
  const [fouten, setFouten] = useState([]);
  useEffect(() => { setFouten([]); }, [location.pathname]);
  useEffect(() => {
    const h = (e) => setFouten((o) => (o.some((f) => f.pad === e.detail.pad) ? o : [...o, e.detail].slice(0, 6)));
    window.addEventListener("bpt:geen-toegang", h);
    return () => window.removeEventListener("bpt:geen-toegang", h);
  }, []);
  if (!fouten.length) return null;
  const redenen = [...new Set(fouten.map((f) => f.reden).filter(Boolean))];
  return (
    <div className="mb-3 flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900" data-testid="geen-toegang-balk" role="status">
      <ShieldAlert className="h-4 w-4 mt-0.5 shrink-0" />
      <div>
        <span className="font-semibold">{fouten.length > 1 ? "Onderdelen van deze pagina zijn" : "Een onderdeel van deze pagina is"} niet beschikbaar voor jouw rol.</span>{" "}
        {redenen.length ? redenen.join(" · ") : "Jouw rol heeft hier geen leesrecht."}{" "}
        <span className="text-amber-700">Heb je dit wel nodig? Vraag een manager om toegang via Accounts &amp; rechten.</span>
      </div>
    </div>
  );
}

function AlleenLezenBalk() {
  const { user, permissies, canRead, canEdit } = useAuth();
  const location = useLocation();
  const module = moduleVoorPad(location.pathname);
  const actief = !!module && !!permissies && user?.role !== "manager_plus" && canRead(module) && !canEdit(module) && !INFORMATIEF_MODULES.has(module);
  const eigen = !!module && EIGEN_MODULES.has(module);
  useEffect(() => {
    const b = document.body.classList;
    b.toggle("alleen-lezen-modus", actief);
    b.toggle("eigen-gegevens", actief && eigen);
    if (actief && !eigen) startAlleenLezenScanner(); else stopAlleenLezenScanner();
    return () => { b.remove("alleen-lezen-modus"); b.remove("eigen-gegevens"); stopAlleenLezenScanner(); };
  }, [actief, eigen]);
  if (!actief) return null;
  return (
    <div className="mb-3 flex items-start gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-900" data-testid="alleen-lezen-balk" role="status">
      <Eye className="h-4 w-4 mt-0.5 shrink-0" />
      <div>
        <span className="font-semibold">Alleen-lezen.</span>{" "}
        {eigen ? (
          <>Je kunt <span className="font-semibold">{module}</span> bekijken en je <span className="font-semibold">eigen gegevens</span> indienen of aanpassen zolang ze nog niet zijn goedgekeurd. Beheer- en keuringsacties zijn niet beschikbaar.</>
        ) : (
          <>Je kunt de module <span className="font-semibold">{module}</span> bekijken, maar niet wijzigen. Bewerkrecht kan een manager toekennen via Rol-permissies of Accounts &amp; rechten.</>
        )}
      </div>
    </div>
  );
}


let _omgevingCache = null;
function TestomgevingBanner() {
  const [preview, setPreview] = useState(_omgevingCache === "preview");
  useEffect(() => {
    if (_omgevingCache) return;
    api.get("/omgeving").then((r) => { _omgevingCache = r.data?.omgeving; setPreview(_omgevingCache === "preview"); }).catch(() => {});
  }, []);
  if (!preview) return null;
  return (
    <div className="mb-3 rounded-md border border-amber-400 bg-amber-100 px-3 py-1.5 text-xs font-semibold tracking-wide text-amber-900 text-center" data-testid="testomgeving-banner" role="status">
      TESTOMGEVING — betalingen, externe mail, WhatsApp/sms en schrijfacties naar OutSmart/Zoho zijn hier geblokkeerd.
    </div>
  );
}
